import { useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext } from '@/context/auth-context'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { AgentV2ConversationsActions } from '../store/slice'
import { selectAgentV2ConversationsWithActivityByMatter, selectAgentV2ListError, selectAgentV2ListLoading } from '../store/selectors'

export function useChatsList(matterId: string) {
  const { user } = useContext(AuthContext)
  const dispatch = useAppDispatch()
  const conversations = useAppSelector((state) => selectAgentV2ConversationsWithActivityByMatter(state, { matterId, currentUserId: user?.uid }))
  const loading = useAppSelector((state) => selectAgentV2ListLoading(state, { matterId }))
  const fullListLoaded = useAppSelector((state) => state.agentV2ConversationsState.fullListLoadedByMatterId[matterId] ?? false)
  const isError = useAppSelector((state) => selectAgentV2ListError(state, { matterId }))
  const [searchQuery, setSearchQuery] = useState('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc')

  useEffect(() => {
    dispatch(AgentV2ConversationsActions.refreshConversationList({ matterId, forceRefresh: false, all: true }))
  }, [dispatch, matterId])

  const rows = useMemo(() => {
    const query = searchQuery.trim().toLocaleLowerCase()
    const filtered = conversations.filter((conversation) => conversation.title.toLocaleLowerCase().includes(query))
    return sortDirection === 'desc' ? filtered : filtered.reverse()
  }, [conversations, searchQuery, sortDirection])

  return {
    rows,
    currentUserId: user?.uid,
    searchQuery,
    setSearchQuery,
    sortDirection,
    toggleSort: () => setSortDirection((direction) => (direction === 'desc' ? 'asc' : 'desc')),
    isLoading: !user || (!fullListLoaded && !isError) || (conversations.length === 0 && loading),
    isError,
    retry: () => dispatch(AgentV2ConversationsActions.refreshConversationList({ matterId, forceRefresh: true, all: true })),
  }
}
